import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/termos-de-uso")({
  head: () => ({
    meta: [
      { title: "Termos de Uso - P2 PRO | Regras e Condições de Uso" },
      { name: "description", content: "Leia os Termos de Uso da P2 PRO. Conheça as condições para utilização do nosso site, serviços e painel de revenda. Transparência legal para sua segurança." },
    ],
  }),
  component: () => (
    <SEOPage
      category="Institucional"
      title="TERMOS DE USO P2 PRO: REGRAS E CONDIÇÕES"
      subtitle="Estabelecemos diretrizes claras para uma parceria sólida, segura e duradoura."
      introParagraphs={[
        "Ao acessar e utilizar o site, o painel gerencial ou qualquer serviço oferecido pela P2 PRO, você concorda integralmente com estes Termos de Uso. Este documento funciona como um contrato de adesão que rege a relação entre a plataforma P2 PRO e seus usuários e revendedores parceiros.",
        "Nossos termos visam garantir a integridade da nossa infraestrutura, a qualidade do serviço entregue ao cliente final e a segurança jurídica de todas as partes envolvidas. É fundamental que você leia atentamente estas diretrizes para entender suas responsabilidades, limitações e direitos ao utilizar nossa tecnologia.",
        "Reservamo-nos o direito de atualizar estes termos periodicamente para refletir mudanças na legislação, novas funcionalidades do sistema ou ajustes operacionais, sempre visando a melhoria contínua da experiência P2 PRO."
      ]}
      benefits={[
        {
          title: "Segurança Jurídica",
          description: "Regras claras que protegem tanto o fornecedor quanto o parceiro revendedor.",
        },
        {
          title: "Padrão de Qualidade",
          description: "Diretrizes de uso que garantem a estabilidade da rede para todos os usuários.",
        },
        {
          title: "Ética Comercial",
          description: "Normas que promovem uma concorrência justa e saudável dentro do ecossistema.",
        }
      ]}
      howItWorks={[
        { title: "Adesão", description: "O uso continuado dos nossos sistemas implica na aceitação automática dos termos vigentes." },
        { title: "Uso do Painel", description: "As credenciais de acesso são de uso pessoal, intransferível e de inteira responsabilidade do parceiro." },
        { title: "Proibições", description: "É expressamente proibido o uso de técnicas de engenharia reversa ou ataques à nossa rede." },
        { title: "Rescisão", description: "O descumprimento das regras pode levar ao bloqueio imediato da conta sem aviso prévio." }
      ]}
      diferenciais={[
        { title: "Clareza Textual", description: "Evitamos termos jurídicos complexos para que você entenda cada cláusula." },
        { title: "Foco na Operação", description: "Termos desenhados para proteger a continuidade do seu negócio de revenda." },
        { title: "Alinhamento Legal", description: "Documento revisado conforme as normas de e-commerce e serviços digitais." }
      ]}
      faq={[
        {
          question: "Posso compartilhar minha senha do painel?",
          answer: "Não. Por questões de segurança e integridade de saldo, o acesso é estritamente pessoal e monitorado por IP."
        },
        {
          question: "O que acontece se eu violar um termo?",
          answer: "Dependendo da gravidade, sua conta pode ser suspensa temporariamente para análise ou banida permanentemente."
        },
        {
          question: "Como fico sabendo de mudanças nos termos?",
          answer: "Sempre publicamos avisos de atualização no dashboard do painel e enviamos comunicados nos canais oficiais."
        }
      ]}
      breadcrumbs={[
        { label: "Institucional", href: "/" },
        { label: "Termos de Uso", href: "/termos-de-uso" }
      ]}
    />
  ),
});
